module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/library/modules/_library.js
// module id = 115
// module chunks = 0